import { render, staticRenderFns } from "./CardTopicos.vue?vue&type=template&id=039c5898&scoped=true&"
import script from "./CardTopicos.vue?vue&type=script&lang=js&"
export * from "./CardTopicos.vue?vue&type=script&lang=js&"
import style0 from "./CardTopicos.vue?vue&type=style&index=0&id=039c5898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039c5898",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VImg,VSheet})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
